import { useEffect, useRef, useState } from "react";
import { Card, Row, Col, Form, Button } from "react-bootstrap";
import Spinner from "../../Components/UI/Spinner/Spinner";
import "./style.css";
import { useFormik } from "formik";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { AddCTargetingAction, GetCTargetingListAction, GetCTargetingSegmentsAction } from "../../Redux/Actions/CtargetingActions";
import ListComponent from "./ListComponent";
import { IReduxState } from "../../utils/types";


const CTargeting = () => {
  const AuthState = useSelector((state: IReduxState) => state.Auth);
  const cTargetingState = useSelector((state: IReduxState) => state.CTargeting);

  const userIDtypes = [ "IDFA", "AD_ID", "IP_ADDRESS", "WEB_ID"];
  const dispatch = useDispatch()
  const fileUploadRef = useRef<HTMLInputElement>(null);
  const [csvFiler, setCsvFiler] = useState<any>({});
  const [regex, setRegex]:any = useState(null);
  const [message, setMessage] = useState('');

  const conditions:any = {
    IDFA: AuthState.audience_idfa,
    AD_ID: AuthState.audience_ad_id,
    IP_ADDRESS: AuthState.audience_ip_address,
    WEB_ID: AuthState.audience_web_id,
  };

  const filteredArray = userIDtypes.filter(type => conditions[type]);

  useEffect(() => {
    dispatch(GetCTargetingSegmentsAction());
  }, [dispatch]);

  

  const handleTypeChange = (type:any) => {
    switch (type) {
      case 'IDFA':
        return { regex: /^[{]?[0-9A-F]{8}-([0-9A-F]{4}-){3}[0-9A-F]{12}[}]?$/, message: "Please enter valid IDFA" };
      case 'AD_ID':
        return { regex: /^[{]?[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}[}]?$/, message: "Please enter valid AD_ID" };
      case 'IP_ADDRESS':
        return { regex: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/i
        , message: "Please use IPv4 address format (X.X.X.X)" };
      case 'WEB_ID':
        return { regex: /^\S+$/, message: "Spaces are not allowed" };
      default:
        return { regex: '', message: '' };
    }
  }

  const setCampaign = (option: any) => {
    //console.log(option.value);
    formik.setFieldValue("campaign", option.value);
  };

  const handleFileUpload = () => {
    if (fileUploadRef) {
      fileUploadRef?.current?.click();
    }
  }


  const handleCSVUpload = (event: any) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    }
    // Check if the selected file is a CSV file
    if (fileObj && fileObj.name.endsWith('.csv')) {

      setCsvFiler(fileObj);
      formik.values.csvFileName = fileObj.name;
      // const ret = validateFile(fileObj);
      let regex = new RegExp('');
    if (formik.values.type === 'IDFA') {
      regex = /^[{]?[0-9A-F]{8}-([0-9A-F]{4}-){3}[0-9A-F]{12}[}]?$/;
    } else if (formik.values.type === 'AD_ID') {
      regex = /^[{]?[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}[}]?$/;
    } else if (formik.values.type === 'IP_ADDRESS') {
      regex = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\n)*(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    } else if (formik.values.type === 'BEESWAX') {
      regex = /[^\s\\]{22}$/;
    }

    const reader = new FileReader();
    reader.onload = (eventer) => {
      const content = eventer.target?.result as string;
      const lines = content.split(/\r\n|\r|\n/);
      for (var i in lines) {
        if (regex.test(lines[i])) {
        } else if (lines[i] !== '') {
          var x = parseInt(i);
          x=x+1;
          alert('CSV file contains values that do not match the type at line: ' + x);
          event.target.value = null;
          formik.values.csvFileName="";
          setCsvFiler({});
          break;
        }
      }
    };
    reader.readAsText(fileObj);
    } else {
      alert('Please select a valid CSV file.');
      event.target.value = null; // Clear the input field
    }
  }

  


  const formik = useFormik({
    initialValues: {
      type: filteredArray[0],
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      isCsv: false,
      csvFileName: "",
      campaign: ""
    },
    validationSchema: yup.object().shape({
      value1: yup.string()
          .matches(
            regex,
            message
          ),
          value2: yup.string()
          .matches(
            regex,
            message
          ),
          value3: yup.string()
          .matches(
            regex,
            message
          ),
          value4: yup.string()
          .matches(
            regex,
            message
          ),
          value5: yup.string()
          .matches(
            regex,
            message
          ),
          value6: yup.string()
          .matches(
            regex,
            message
          )
          
    }),
    onSubmit: (value, { resetForm }) => {
      const formData = new FormData();
      formData.append('csvfile', csvFiler)
      formData.append('campaign', value.campaign);
      formData.append('isCsv', value.isCsv ? "true" : "false");
      formData.append('type', value.type);
      formData.append('value1', value.value1);
      formData.append('value2', value.value2);
      formData.append('value3', value.value3);
      formData.append('value4', value.value4);
      formData.append('value5', value.value5);
      formData.append('value6', value.value6);


      dispatch(AddCTargetingAction(formData))
      setCsvFiler({});
      resetForm({
        values: {
          type: filteredArray[0],
          value1: "",
          value2: "",
          value3: "",
          value4: "",
          value5: "",
          value6: "",
          isCsv: false,
          csvFileName: "",
          campaign: ""
        }
      })
    },
  });

  useEffect(() => {
    const { regex, message } = handleTypeChange(formik.values.type);
    setRegex(regex);
    setMessage(message);
  }, [formik.values.type]);

  useEffect(() => {
    dispatch(GetCTargetingListAction(''));
  }, [dispatch]);


  const downloadCSVFile = () => {
    let csvContent: any;
    let fileName;
    csvContent = "AADbIE7MiYQAABUzAjtgTg\nAAGI3E7Mm2QAABUVNaeASg\nBAFAE7Mn4RaABPVTaeASgT";
        fileName = 'Upload_Audience_Example';

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${fileName}.csv`;

    a.click();
    window.URL.revokeObjectURL(url);
}

  return (
    <>
      {cTargetingState?.loading && (<div className="popUpUser"><Spinner className="m-2" color={"primary"}></Spinner></div>)}
      <Row className="d-flex justify-content-center mt-3">
        <Row>
          <h3 className="module_title">
            UPLOAD AUDIENCE
          </h3>
        </Row>
      </Row>
      <Card>
      
        <Row style={{ padding: "15px" }}>
          <Row>
            <Col lg={14}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={1}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  Users Type
                </Form.Label>
                <Col lg={11}>
                  <Form.Select
                    name="type"
                    value={formik.values.type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem "
                  >
                             {filteredArray.map((type, index) => (
          <option key={index}>{type}</option>
        ))}               
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col lg={14}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={1} id="smallerFontSize">
                  Upload Type
                </Form.Label>
                <Col lg={11}>
                  <div className="checkboxes" >
                    <Form.Check
                      type="radio"
                      name="csvType"
                      value="off"
                      onChange={() => formik.setFieldValue("isCsv", false)}
                      checked={formik.values.isCsv === false ? true : false}
                    />{" "}
                    <Form.Label
                      style={{ marginLeft: "15px" }}
                      column
                      lg={2}
                      id="smallerFontSize"
                    >
                      {" "}
                      Single Users{" "}
                    </Form.Label>
                    <Form.Check
                      type="radio"
                      name="csvType"
                      value="on"
                      onChange={() => formik.setFieldValue("isCsv", true)}
                      checked={formik.values.isCsv === true ? true : false}
                    // onBlur={formik.handleBlur}
                    ></Form.Check>{" "}
                    <Form.Label
                      style={{ marginLeft: "15px" }}
                      column
                      lg={2}
                      id="smallerFontSize"
                    >
                      {" "}
                      CSV File{" "}
                    </Form.Label>
                  </div>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          {cTargetingState?.segmentData.length > 0 &&
            <Row>
              <Col lg={14}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Form.Label
                    column
                    lg={1}
                    htmlFor="simpleinput"
                    id="smallerFontSize"
                  >
                    Select Campaign
                  </Form.Label>
                  <Col lg={11}>
                    <Select
                      isMulti={false}
                      onChange={setCampaign}
                      onBlur={formik.handleBlur}
                      className="fsz-875rem "
                      // className="react-select react-select-container"
                      // classNamePrefix="react-select"
                      options={cTargetingState?.segmentData?.map((item: any) => {
                        return { value: item.value, label: item.name };
                      })}
                    ></Select>
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          }</Row>
      </Card>
      <Card>
        <Row style={{ padding: "15px" }}>
          <Row>
            <Col lg={15}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label
                  column
                  lg={1}
                  htmlFor="simpleinput"
                  id="smallerFontSize"
                >
                  CSV File
                </Form.Label>
                <input
                  ref={fileUploadRef}
                  style={{ display: 'none' }}
                  type="file"
                  accept=".csv"
                  onChange={(e) => handleCSVUpload(e)}
                />
                <Col lg={1}>
                  <Button className="m-0" variant="primary" disabled={!formik.values.isCsv} onClick={() => handleFileUpload()}>Upload CSV</Button>
                </Col>
                <Col className="col-9 col-md-6">
                  <Form.Control
                    name="csvFileName"
                    value={formik.values.csvFileName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    disabled={!formik.values.isCsv}
                  />
                </Col>
                <Col lg={2}>
                  {/* <div className="d-flex flex-wrap gap-2"> */}
                    <span
                      style={{
                        textDecoration: "none",
                        color: "#0077b6",
                        fontWeight: "bold",
                        // margin: "5px",
                        cursor: "pointer",
                      }}
                      onClick={() => downloadCSVFile()}
                    >
                      Download CSV Example
                    </span>
                  {/* </div> */}
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #1
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value1"
                    disabled={formik.values.isCsv}
                    value={formik.values.value1}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value1}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value1} </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #2
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value2"
                    disabled={formik.values.isCsv}
                    value={formik.values.value2}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value2}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value2} </Form.Control.Feedback>
                </Col>
              </Form.Group>

              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #3
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value3"
                    disabled={formik.values.isCsv}
                    value={formik.values.value3}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value3}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value3} </Form.Control.Feedback>
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #4
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value4"
                    disabled={formik.values.isCsv}
                    value={formik.values.value4}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value4}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value4} </Form.Control.Feedback>
                </Col>
              </Form.Group>
              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  Value #5
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value5"
                    disabled={formik.values.isCsv}
                    value={formik.values.value5}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value5}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value5} </Form.Control.Feedback>
                </Col>
              </Form.Group>


              <Form.Group
                as={Row}
                className="mb-3"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Form.Label column lg={2} id="smallerFontSize">
                  value #6
                </Form.Label>
                <Col lg={10}>
                  <Form.Control
                    name="value6"
                    disabled={formik.values.isCsv}
                    value={formik.values.value6}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="fsz-875rem"
                    isInvalid={!!formik.errors.value6}
                  />
                  <Form.Control.Feedback type="invalid">{formik.errors?.value6} </Form.Control.Feedback>
                </Col>
              </Form.Group>


            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col>
              <Button
                style={{ marginLeft: "0", fontWeight: "700" }}
                variant="primary"
                onClick={() => {
                  formik.handleSubmit();
                  // setCsvFiler("");
                }}
                disabled={(formik.values.isCsv && formik.values.csvFileName==="") || (!formik.values.isCsv && formik.values.value1 === "" && formik.values.value2 === "" && formik.values.value3 === "" &&
                  formik.values.value4 === "" && formik.values.value5 === "" && formik.values.value6 === "")}
              >
                Upload Audience
              </Button>

            </Col>
          </Row>
        </Row>
      </Card>

      <Card>
        <Row style={{ padding: "15px" }}>
          <ListComponent historyData={cTargetingState.historyData} upload_segmets={cTargetingState?.segmentData} />
        </Row>
      </Card>
    </>
  );
};

export default CTargeting;